// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "hash": "5419b57",
    "fullHash": "5419b57c4333e082665970d01c04beda52cdaebc",
    "branch": "HEAD",
    "tag": "R-26-3.1.2"
};
/* tslint:enable */
/* eslint-enable */
